import React, { useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { auth } from "../../firebase-config"; // Import your Firebase config
import "../../styles/dashboard.css";

const Dashboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      if (!user) {
        // Redirect to login if not authenticated
        navigate('/admin/login');
      }
    });

    return () => unsubscribe();  // Clean up the listener on unmount
  }, [navigate]);

  return (
    <div className="dashboard">
      <h1>Admin Dashboard</h1>
      <NavLink to="/admin/departments" className="dashboard-btn">
        Manage Departments
      </NavLink>
    </div>
  );
};

export default Dashboard;
